module.exports = __webpack_public_path__ + "img/obs-transparency.bff9bf01.png";